interface DiscCountry {
  langCode: string
  currency: string
  priceKey: string
}

// update this list as needed for
// depending on the countries the discount should apply to
const discountCountry: DiscCountry[] = [
  { langCode: 'da', currency: 'DKK', priceKey: 'TILBUD' },
  // { langCode: 'no', currency: 'NOK', priceKey: 'TILBUD_NOK' },
]

// update discount time in this function
// remember month is month INDEX (values 0 - 11)
function isDiscountTime(): boolean {
  const startDate = Date.UTC(2026, 9, 1, 0, 0, 0);
  const endDate = Date.UTC(2026, 11, 31, 21, 59, 59);
  const now = Date.now();

  return now >= startDate && now < endDate;
}

// Prices for DKK are fetched live from uCommerce. TILBUD is set when salePrice < listPrice.
export function isDiscount(repo: { langCode: string }, currency: string): boolean {
  return isDiscountTime() && discountCountry.some(country => country.langCode === repo.langCode && country.currency === currency);
}

export function getDiscountPriceKey(repo: { langCode: string }, currency: string): string | null {
  const match = discountCountry.find(country => country.langCode === repo.langCode && country.currency === currency);
  return match?.priceKey ?? null;
}
